<template>
  <div>
    <div class="plan br4 pa4-l pa3" :class="planClasses(plan) " v-for="plan in state.plans" :key="plan.id"
      :data-test-id="`${plan.id}`">

      <div class="flex-l flex-row-l flex-column justify-between">
        <div class="w-60-l mb2 tc tl-l">
          <h3>
            {{ plan.display_name}}
            <span class="text-normal f3" v-if="!plan.custom">{{ plan.price > 0 ? currency(plan.price) : "Free" }}</span>
          </h3>

          <span v-if='plan.custom'>
            Custom
            <em class="f3">(Discounts available)</em>

          </span>
          <span class="pricing" v-else>
            {{ currency(state.totalsForPlan(plan.id).sum) }} USD/month
          </span>
        </div>

        <div class="flex w-40-l">

          <contact-sales-modal v-if="plan.custom" class="db w-100">
            <button data-posthog-action="calc:openSalesModal" class="cta w-100 pointer tc yellow-cta">Contact
              Sales</button>
          </contact-sales-modal>

          <a v-else class="cta pointer w-100 tc" :data-posthog-action="`calc:signUp${plan.name}`"
            :href="`/signup?plan=${plan.name}`">Sign Up</a>
        </div>
      </div>

      <pricing-details v-if="!plan.custom" :plan-id="plan.id" />

      <p v-else class="i">
        <a href="/enterprises">Learn more</a> about the benefits of an enterprise account.
      </p>
    </div>

  </div>
</template>

<script>
import ContactSalesModal from '../contact-sales-modal/component.vue';
import PricingDetails from './pricing-details.vue';

export default {
  name: 'PricingResults',

  components: { PricingDetails, ContactSalesModal },
  inject: ['state'],

  provide () {
    return { state: this.state, currency: this.currency };
  },

  methods: {
    currency: function (num) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(num);
    },

    planClasses (plan) {
      const classes = [];
      if (plan.custom) return [];

      const hasSeats = plan.price_per_seat;

      if (!hasSeats && this.state.seats > 1) classes.push('disabled');
      if (this.state.seats > 5) classes.push('disabled');
      if (plan.popular) classes.push('popular');
      return classes;
    }
  }
};
</script>

<style scoped lang="scss">

@import "~/stylesheets/application/colors";

.plan {
  border: 1px solid $gray-200;
  margin-bottom: .6rem;
  transition: all .3s ease;

  &:hover {
    transform: scale(102%);
  }

  &.popular {
    background-color: $sand;
  }

  a {
    transition: opacity 1s .5s ease-out;
  }

  &.disabled {
    opacity: .4;
    pointer-events: none;
    filter: grayscale(1);

    details {
      display: none;
    }

    a {
      opacity: .4
    }

    .pricing {
      opacity: .4;
      text-decoration: line-through;
    }
  }
}

</style>
